import {Injectable} from "@angular/core";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {QrCopyMessageComponent} from "./qr-copy.component";

@Injectable({
  providedIn: 'root'
})
export class SnackBarUtil {

  public static readonly CLASSES = {
    error: ['error-snackbar'],
    success: ['green-snackbar'],
    info: ['info-snackbar']
  }

  constructor(
    private snackBar: MatSnackBar
  ) {
  }

  public openSnackBar(config: MatSnackBarConfig) {
    this.snackBar.openFromComponent(QrCopyMessageComponent, config);
  }
}
